var React = require('react');

function MimeText (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 1h12.023a1 1 0 0 1 0 2H2a1 1 0 1 1 0-2zm0 4h12.023a1 1 0 0 1 0 2H2a1 1 0 0 1 0-2zm0 4h12.023a1 1 0 0 1 0 2H2a1 1 0 1 1 0-2zm0 4h5a1 1 0 1 1 0 2H2a1 1 0 0 1 0-2z"}));
}

MimeText.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = MimeText;

MimeText.default = MimeText;
